import { render, staticRenderFns } from "./formviews.vue?vue&type=template&id=6e2ac97f"
import script from "./formviews.vue?vue&type=script&lang=js"
export * from "./formviews.vue?vue&type=script&lang=js"
import style0 from "./formviews.vue?vue&type=style&index=0&id=6e2ac97f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports